import { User, windowExtended } from '@map/types';
import { deepEqual } from '@shared/util/object';
import { Reducer } from 'redux';

const initialState = (
  windowExtended.invitation ? { locale: windowExtended.invitation.locale } : {}
) as Partial<User>;

type State = typeof initialState;

/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
export const USER_LOGGED_IN = 'USER_LOGGED_IN' as const;
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT' as const;
const USER_UPDATED = 'USER_UPDATED' as const;
export const USER_FETCHED = 'USER_FETCHED' as const;
/* eslint-enable @typescript-eslint/no-unnecessary-type-assertion */

export const actionCreators = {
  userLoggedIn: (data: User) => ({ type: USER_LOGGED_IN, data }),
  userLoggedOut: () => ({ type: USER_LOGGED_OUT }),
  userUpdated: (data: Partial<User>) => ({ type: USER_UPDATED, data }),
  userFetched: (data: Partial<User>) => ({ type: USER_FETCHED, data }),
};

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;

const user: Reducer<State, Action> = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGGED_IN:
    case USER_UPDATED:
      return action.data;
    case USER_FETCHED: {
      const newState = action.data;
      // if we are signed in on the server or the client then sync the local state to remote,
      // unless they are equal, in which case avoid a useless re-render
      if ((newState.id || state.id) && !deepEqual(newState, state)) {
        return newState;
      }
      // we are in the onboarding process so don't
      // wipe local state that hasn't been persisted
      return state;
    }
    default:
      return state;
  }
};

export default user;

export const userSelector = (state: { user: State }) => state.user;
